// Generated by Melange

import * as Buhta_cabinet__Button from "../../html/Button.js";
import * as Buhta_cabinet__Calendar from "./Calendar.js";
import * as Buhta_cabinet__CalendayMonthSelect from "./CalendayMonthSelect.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(onPickedOpt) {
  const onPicked = onPickedOpt !== undefined ? onPickedOpt : (function (param) {
        
      });
  return function (tillCurrentDateOpt) {
    const tillCurrentDate = tillCurrentDateOpt !== undefined ? tillCurrentDateOpt : false;
    return function (displayCurrentDateOpt) {
      const displayCurrentDate = displayCurrentDateOpt !== undefined ? displayCurrentDateOpt : true;
      return function (isBirthDayOpt) {
        const isBirthDay = isBirthDayOpt !== undefined ? isBirthDayOpt : false;
        return function (tillExactYearOpt) {
          const tillExactYear = tillExactYearOpt !== undefined ? tillExactYearOpt : 2035;
          const currentDate = DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
          const match = React.useState(function () {
                return [
                        DateTime.month(currentDate),
                        DateTime.year(currentDate)
                      ];
              });
          const setMonthYear = match[1];
          const match$1 = match[0];
          const year = match$1[1];
          const month = match$1[0];
          const match$2 = React.useState(function () {
                
              });
          const setSelectedDate = match$2[1];
          const selectedDate = match$2[0];
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_cabinet__CalendayMonthSelect.make, {
                              value: [
                                month,
                                year
                              ],
                              onChange: (function (month, year) {
                                  Curry._1(setMonthYear, (function (param) {
                                          return [
                                                  month,
                                                  year
                                                ];
                                        }));
                                }),
                              isBirthDay: isBirthDay,
                              tillExactYear: tillExactYear
                            }),
                        JsxRuntime.jsx(Buhta_cabinet__Calendar.make, {
                              month: month,
                              year: year,
                              selectedStartDay: selectedDate,
                              selectedEndDay: undefined,
                              tillCurrentDate: tillCurrentDate,
                              displayCurrentDate: displayCurrentDate,
                              onDaySelected: (function (day) {
                                  Curry._1(setSelectedDate, (function (param) {
                                          return Caml_option.some(day);
                                        }));
                                  Curry._1(onPicked, day);
                                })
                            }),
                        JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                              size: "m",
                              kind: "secondary",
                              className: "mt-6",
                              disabled: selectedDate === undefined,
                              isWide: true,
                              onClick: (function (param) {
                                  if (selectedDate !== undefined) {
                                    return Curry._1(onPicked, Caml_option.valFromOption(selectedDate));
                                  }
                                  
                                }),
                              children: "Выбрать"
                            })
                      ],
                      className: "p-4 bg-black rounded inline-block w-80"
                    });
        };
      };
    };
  };
}

function CalendarDatePicker(Props) {
  return Curry._3(make(Props.onPicked)(Props.tillCurrentDate), Props.displayCurrentDate, Props.isBirthDay, Props.tillExactYear);
}

const make$1 = CalendarDatePicker;

export {
  make$1 as make,
}
/* Buhta_cabinet__Button Not a pure module */
